export const rollcallrejoinemployeelistdata = [
    {
        biometric: "BIO12345",
        name: "John Doe",
        designation: "Software Engineer",
        department: "IT",
        date: "01-03-2025",
        reason: "Medical Leave",
        mobile: "9876543210"
    },
    {
        biometric: "BIO12346",
        name: "Jane Smith",
        designation: "HR Manager",
        department: "Human Resources",
        date: "03-03-2025",
        reason: "Maternity Leave",
        mobile: "9876543211"
    },
    {
        biometric: "BIO12347",
        name: "Amit Kumar",
        designation: "Accountant",
        department: "Finance",
        date: "27-02-2025",
        reason: "Personal Leave",
        mobile: "9876543212"
    },
    {
        biometric: "BIO12348",
        name: "Priya Sharma",
        designation: "Marketing Executive",
        department: "Marketing",
        date: "25-02-2025",
        reason: "Sabbatical",
        mobile: "9876543213"
    },
    {
        biometric: "BIO12349",
        name: "Robert Brown",
        designation: "Product Manager",
        department: "Product Management",
        date: "05-03-2025",
        reason: "Business Travel",
        mobile: "9876543214"
    },
    {
        biometric: "BIO12350",
        name: "Maria Lopez",
        designation: "UI/UX Designer",
        department: "Design",
        date: "04-03-2025",
        reason: "Family Emergency",
        mobile: "9876543215"
    },
    {
        biometric: "BIO12351",
        name: "Sunil Gupta",
        designation: "DevOps Engineer",
        department: "IT",
        date: "02-03-2025",
        reason: "Training",
        mobile: "9876543216"
    },
    {
        biometric: "BIO12352",
        name: "Emily Clark",
        designation: "Business Analyst",
        department: "Operations",
        date: "01-03-2025",
        reason: "Vacation",
        mobile: "9876543217"
    },
    {
        biometric: "BIO12353",
        name: "Ravi Verma",
        designation: "Legal Advisor",
        department: "Legal",
        date: "28-02-2025",
        reason: "Medical Leave",
        mobile: "9876543218"
    },
    {
        biometric: "BIO12354",
        name: "Sophia Martinez",
        designation: "Sales Manager",
        department: "Sales",
        date: "03-03-2025",
        reason: "Parental Leave",
        mobile: "9876543219"
    },
    {
        biometric: "BIO12355",
        name: "Vikram Singh",
        designation: "QA Engineer",
        department: "Quality Assurance",
        date: "01-03-2025",
        reason: "Sick Leave",
        mobile: "9876543220"
    },
    {
        biometric: "BIO12356",
        name: "Lisa Kim",
        designation: "Content Writer",
        department: "Content",
        date: "27-02-2025",
        reason: "Relocation",
        mobile: "9876543221"
    }
];
